<template>
  <div id="app">
    <component :is="layout">
    </component>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'App',
  computed: {
    ...mapGetters('auth', [
      'isAuthenticated',
      'currentUser',
    ]),
    layout() {
      return `${(this.$route.meta.layout || 'default')}-layout`;
    },
  },
  beforeCreate() {
    this.$store.dispatch('auth/assignRoutes');
  },
  created() {
    this.isAuthenticated.then(async (userInfo) => {
      if (userInfo && !this.currentUser) {
        if (window.appInsights) {
          window.appInsights.setAuthenticatedUserContext(userInfo.profile.preferred_username.replace(/[,;=| ]+/g, '_'));
        }

        await this.$store.dispatch('auth/setCurrentUser', userInfo);
        await this.$store.dispatch('auth/getUserProfile');

        const redirectPath = window.localStorage.getItem('auth:redirect');
        if (redirectPath) {
          window.localStorage.removeItem('auth:redirect');
          this.$router.push({
            path: redirectPath,
          });
        }
      }
    });
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue